<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import Infobox from "../Infobox.svelte";
    import ErrorBox from "../form/ErrorBox.svelte";
    import BankAccountBox from "../form/BankAccountBox.svelte";
    import {ASSET_URL} from "../../config";
    import {entityStore, myStore} from "../../stores.js";
    import {json} from "svelte-i18n";

    const dispatch = createEventDispatcher();

    let submitted:Boolean = false;
    export let disabledFields = true;
    let validStep = null;
    const stepKey = "step5";

    let availableCommunities = [];
    $: availableCommunities = $entityStore.availableCommunities;
    /*
    function onSubmitBtnClicked(){
       dispatch('submitBtnClicked');
    }
    */

    //let backAccountItems =

    const add = () => {
        console.log("add bankinfo");

        $myStore.addField(`step5.bankAccounts`,{iban: null, files: [], community_id: null}, $myStore.data.step5.bankAccounts.length + 1);
        //$form.orderItems = $form.orderItems.concat({description: '',quantity: '', notice: '', articleNumber: ''});
        //$errors.orderItems = $errors.orderItems.concat({description: '',quantity: '', notice: '', articleNumber: ''});
    };

    const remove = index => () => {
        console.log("remove bankinfo at index: ",index);
        $myStore.unsetField(`step5.bankAccounts.${index}`);

        //$form.orderItems = $form.orderItems.filter((u, j) => j !== i);
        //$errors.orderItems = $errors.orderItems.filter((u, j) => j !== i);
    };
    function checkValidity(key){
        let steps =  $entityStore.steps;
        const index = steps.findIndex((s) => s.key == key)
        if(steps[index]){
            validStep = steps[index].valid; // !step.valid && step.touched;

            steps[index].touched = true;

            if(validStep){
                //open next accordion
                if(index < steps.length){
                }

            }

            entityStore.update($entityStore => ({
                ...$entityStore,
                steps
            }));
        }
    }

    function validateCurrentStep(){
        submitted = true;
        //validateStep(stepKey);
        checkValidity(stepKey)

        console.log("steps after: ",$entityStore.steps);
    }

    console.log(":::available com ? ", $entityStore.availableCommunities);



</script>
<!-- translation example: {$_('introText')}-->
<div class="step">

    <div class="section no-border">

        <Infobox customClass="mb-4">
            Afin que le ministère puisse engager et verser les subventions accordées, veuillez indiquer ici les
            coordonnées bancaires de votre·vos commune·s ou de votre syndicat intercommunal, en joignant un Relevé
            d'identité bancaire (RIB).
            <br><br>
            Attention: Même si plusieurs communes signent le pacte communal ensemble, en tant que groupe de communes,
            les subventions seront en principe versées à chaque commune séparément. Ce n'est que si un syndicat est
            chargé de la coordination du pacte communal d'un groupe de communes que les subventions peuvent être mises
            en commun et versées à ce même syndicat.
        </Infobox>

        <h3 class="title pt-3">Veuillez indiquer les coordonnées bancaires</h3>
        <div class="bank-account-repeater">
            {#each $myStore.data.step5.bankAccounts as item,index}
            <BankAccountBox disabled={disabledFields} {index} on:remove={remove(index)}></BankAccountBox>
            {/each}

            {#if $myStore.data.step2.pactIsSignedBySyndicate !== true && $entityStore.availableCommunities?.length > 1 }
                <div class="add-btn-box">
                    <div class="add-btn" on:click={add}>
                        <img src="{ASSET_URL}/assets/img/icons/add.svg"/>
                    </div>
                </div>
            {/if}
        </div>
    </div>

    {#if submitted && !validStep}
        <ErrorBox>Veuillez indiquer les coordonnées bancaires de toutes les communes concernées par cette demande, en joignant un Relevé d'identité bancaire (RIB). Les subventions seront versées à chaque commune séparément. En cas d’une demande introduite par un syndicat intercommunal chargé de la coordination du pacte communal, les subventions peuvent être mises en commun et versées à ce même syndicat. Dans ce cas, veuillez l'indiquer dans la partie « adhésion au pacte » du formulaire et fournir les coordonnées bancaires du syndicat intercommunal attestées par un RIB.</ErrorBox>
    {/if}
    {#if !submitted || !validStep}
        <div class="step-validation-btn">
            <button disabled={disabledFields} class="mt-2 btn btn-brand submitBtn" on:click={validateCurrentStep}>continuer</button>
        </div>
    {/if}


</div>


<style lang="scss">

  .bank-account-repeater{

    display:flex;
    flex-direction:column;
    //margin-top:3rem;
    margin-bottom:3rem;
    row-gap: 2rem;

  }

  .add-btn-box{
    display: flex;
    //align-items: center;
    justify-content: center;
    margin-top: 2rem;
  }

  .add-btn{
    background:$secondary-color;
    color:white;
    border-radius:9px;
    cursor:pointer;
    padding:10px;
    display:inline-flex;
    align-content: center;
    justify-content: center;

    img{
      height:1.5rem;
      width:1.5rem;
    }
  }
</style>
